// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"5f0c6ed8","561":"72d19aa6","695":"c477ed90","777":"49482a76"}[chunkId] + ".chunk.js";
};